import vuerouter from "vue-router";
import AdministracionDeProspectos from "./views/AdministracionDeProspectos.vue";
import AdministracionDeClientes from "./views/AdministracionDeClientes.vue";
import AdministracionDePendientes from "./views/AdministracionDePendientes.vue";
import RegistroProspecto from "./views/RegistroProspecto.vue";
import RegistroLlamada from "./views/RegistroLlamada.vue";
import ResultadoLlamada from "./views/ResultadoLlamada.vue";
import RegistroCita from "./views/RegistroCita.vue";
import ResultadoCita from "./views/ResultadoCita.vue";
import IntegracionExpediente from "./views/IntegracionExpediente.vue";
import FormularioSolicitudInscripcion from "./views/FormularioSolicitudInscripcion.vue";
import FormularioSolicitudInscripcionEx from "./views/FormularioSolicitudInscripcionex.vue";
import FormularioSolicitudInscripcionMoral from "./views/FormularioSolicitudInscripcionMoral.vue";
import IntegracionExpedienteExtranjero from "./views/IntegracionExpedienteExtranjero.vue";
import IntegracionExpedienteMoral from "./views/IntegracionExpedienteMoral.vue";
import PreAutorizacion from "./views/PreAutorizacion.vue";
import CuestionarioPreAnalisisPersonaMoral from "./views/CuestionarioPreAnalisisPersonaMoral.vue";
import GenerarInformacionDePago from "./views/GenerarInformacionDePago.vue";
import SeguimientoProspecto from "./views/SeguimientoProspecto.vue";
import CargarInformacionDePago from "./views/CargarInformacionDePago.vue";
import ValidarPago from "./views/ValidarPago.vue";
import Bienvenida from "./views/Bienvenida.vue";
import IntegracionExpedienteIncode from "./views/IntegracionExpedienteIncode.vue";
import IntegracionExpedienteIncodeV2 from "./views/IntegracionExpedienteIncodeV2.vue"
import HojaPrueba from "./views/HojaPrueba.vue";
import HojaPruebaExtranjero from "./views/HojaPruebaExtranjero.vue";
import HojaPruebaMoral from "./views/HojaPruebaMoral.vue";
import CajaDorada from "./views/CajaDorada.vue";
import Dashboard from "./views/Dashboard.vue";
import Dashboard2 from "./views/Dashboard2.vue";
import Administrador from "./views/Administrador.vue";
import AdministradorComercial from "./views/AdministradorComercial.vue";
import AltaPerfil from "./views/AltaPerfil.vue";
import DatosPersonalesFiguraAdicional from "./views/DatosPersonalesFiguraAdicional.vue";
import DatosPersonalesFiguraAdicionalex from "./views/DatosPersonalesFiguraAdicionalex.vue";
import WelcomeOnBoradingSlidesVue from "./views/WelcomeOnBoradingSlides.vue";
import ErrorOnBoarding from "./views/ErrorOnBoarding.vue"
import InformacionAutenticacionIdentidad from "./views/InformacionAutenticacionIdentidad.vue";

const rutasProspecto = (vuerouter.RouteRecordRaw = [{
        name: "AdministracionDeProspectos",
        path: "AdministracionDeProspectos",
        component: AdministracionDeProspectos,
    },
    {
        path: "AdministracionDeClientes",
        component: AdministracionDeClientes,
    },
    {
        path: "AdministracionDePendientes",
        component: AdministracionDePendientes,
    },    
    {
        name: "RegistroProspecto",
        path: "/RegistroProspecto",
        component: RegistroProspecto,
    },
    {
        name: "RegistroLlamada",
        path: "RegistroLlamada",
        component: RegistroLlamada,
    },
    {
        name: "ResultadoLlamada",
        path: "ResultadoLlamada",
        component: ResultadoLlamada,
    },
    {
        name: "IntegracionExpedienteIncodeV2",
        path: "IntegracionExpedienteIncodeV2",
        component: IntegracionExpedienteIncodeV2,
    },
    {
        name: "IntegracionExpedienteIncode",
        path: "IntegracionExpedienteIncode",
        component: IntegracionExpedienteIncode,
    },
    {
        name: "RegistroCita",
        path: "RegistroCita",
        component: RegistroCita,
    },
    {
        name: "ResultadoCita",
        path: "ResultadoCita",
        component: ResultadoCita,
    },
    {
        name: "IntegracionExpediente",
        path: "IntegracionExpediente",
        component: IntegracionExpediente,
    },
    {
        name: "FormularioSolicitudInscripcion",
        path: "FormularioSolicitudInscripcion",
        component: FormularioSolicitudInscripcion,
    },
    {
        name: "FormularioSolicitudInscripcionex",
        path: "FormularioSolicitudInscripcionex",
        component: FormularioSolicitudInscripcionEx,
    },
    {
        name: "FormularioSolicitudInscripcionMoral",
        path: "FormularioSolicitudInscripcionMoral",
        component: FormularioSolicitudInscripcionMoral,
    },
    {
        name: "IntegracionExpedienteExtranjero",
        path: "IntegracionExpedienteExtranjero",
        component: IntegracionExpedienteExtranjero,
    },
    {
        name: "IntegracionExpedienteMoral",
        path: "IntegracionExpedienteMoral",
        component: IntegracionExpedienteMoral,
    },
    {
        name: "PreAutorizacion",
        path: "PreAutorizacion",
        component: PreAutorizacion,
    },
    {
        name: "CuestionarioPreAnalisisPersonaMoral",
        path: "CuestionarioPreAnalisisPersonaMoral",
        component: CuestionarioPreAnalisisPersonaMoral,
    },
    {
        name: "GenerarInformacionDePago",
        path: "GenerarInformacionDePago",
        component: GenerarInformacionDePago,
    },
    {
        name: "SeguimientoProspecto",
        path: "SeguimientoProspecto",
        component: SeguimientoProspecto,
    },
    {
        name: "CargarInformacionDePago",
        path: "CargarInformacionDePago",
        component: CargarInformacionDePago,
    },
    {
        name: "ValidarPago",
        path: "ValidarPago",
        component: ValidarPago,
    },
    {
        name: "Bienvenida",
        path: "Bienvenida",
        component: Bienvenida,
    },
    {
        name: "HojaPrueba",
        path: "HojaPrueba",
        component: HojaPrueba,
    },
    {
        name: "HojaPruebaExtranjero",
        path: "HojaPruebaExtranjero",
        component: HojaPruebaExtranjero,
    },
    {
        name: "HojaPruebaMoral",
        path: "HojaPruebaMoral",
        component: HojaPruebaMoral,
    },
    {
        name: "CajaDorada",
        path: "CajaDorada",
        component: CajaDorada,
    },
    {
        name: "Dashboard",
        path: "Dashboard",
        component: Dashboard,
    },
    {
        name: "Dashboard2",
        path: "Dashboard2",
        component: Dashboard2,
    },
    {
        name: "Administrador",
        path: "Administrador",
        component: Administrador,
    },
    {
        name: "AdministradorComercial",
        path: "AdministradorComercial",
        component: AdministradorComercial,
    },
    {
        name: "DatosPersonalesFiguraAdicional",
        path: "DatosPersonalesFiguraAdicional",
        component: DatosPersonalesFiguraAdicional,
    },
    {
        name: "DatosPersonalesFiguraAdicionalex",
        path: "DatosPersonalesFiguraAdicionalex",
        component: DatosPersonalesFiguraAdicionalex,
    },
    {
        name: "AltaPerfil",
        path: "AltaPerfil/:tipo",
        component: AltaPerfil,
    },
    {
        name: "EditarPerfil",
        path: "EditarPerfil/:id:tipo",
        component: AltaPerfil,
    },
    {
        name: "InformacionAutenticacionIdentidad",
        path: "InformacionAutenticacionIdentidad",
        component: InformacionAutenticacionIdentidad,
      },
      {
        name: "WelcomeOnBoarding",
        path: "welcomeOnboarding",
        component: WelcomeOnBoradingSlidesVue,
      },
      {
        name: "ErrorOnBoarding",
        path: "errorOnboarding",
        component: ErrorOnBoarding,
      },
]);
export default rutasProspecto;